module.exports = __webpack_public_path__ + "img/mg.86f8e095.svg";